module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$i18n.locale === 'de' || _vm.$i18n.locale === 'de-at') ? _c('login-de') : _c('login-en')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01a87bb3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 463
// module chunks = 0